'use client';

import { useStore } from 'zustand';

import { CartDrawer } from './cart-drawer.component';
import { CartGuidance } from './guidance/cart-guidance.component';
import { CartModalKeys } from './_types/cart-modal-keys.enum';

import { ProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.component';
import { useProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.hook';
import { useCartNavigation } from '@/hooks/use-cart-navigation.hook';
import { cartStore, closeCart } from '@/store/cart/cart.store';

function CartStep() {
  const { handleJump } = useProgressiveModal<CartModalKeys>();
  const { addProcedure, goToSearch } = useCartNavigation();

  return (
    <CartDrawer
      onAddProcedure={addProcedure}
      onSearch={goToSearch}
      onProceed={() => handleJump({ key: CartModalKeys.GUIDANCE })}
    />
  );
}

function GuidanceStep() {
  const { handleJump } = useProgressiveModal<CartModalKeys>();

  return <CartGuidance onBack={() => handleJump({ key: CartModalKeys.CART, returning: true })} />;
}

export function CartModal() {
  const isOpen = useStore(cartStore, (state) => state.isOpen);

  return (
    <ProgressiveModal
      open={isOpen}
      initialKey={CartModalKeys.CART}
      handleClose={closeCart}
      sheetSide="right"
      hasHeader
      title="Carrinho"
      className="w-full gap-0 sm:w-[25rem]"
      contentPadding={false}
      contentLayout="column"
      onOpenAutoFocus={({ event }) => event.preventDefault()}
      onInteractOutside={({ event }) => {
        if ((event.target as Element | null)?.closest('[data-toast-viewport]')) {
          event.preventDefault();
        }
      }}
    >
      <CartStep key={CartModalKeys.CART} />
      <GuidanceStep key={CartModalKeys.GUIDANCE} />
    </ProgressiveModal>
  );
}
